<template>
    <div id="emotion_expand" class="container-fluid" v-bind:class="[{ active: active }, selectedEmotion]">
        <div v-show="selectedEmotion == 'happy'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Happy</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Playful</li>
                    <li>Content</li>
                    <li>Interested</li>
                    <li>Proud</li>
                    <li>Accepted</li>
                    <li>Powerful</li>
                    <li>Peaceful</li>
                    <li>Trusting</li>
                    <li>Optimistic</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Aroused</li>
                    <li>Free</li>
                    <li>Curious</li>
                    <li>Succesful</li>
                    <li>Respected</li>
                    <li>Courageous</li>
                    <li>Loving</li>
                    <li>Sensitive</li>
                    <li>Hopeful</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Cheeky</li>
                    <li>Joyful</li>
                    <li>Inquisitive</li>
                    <li>Confident</li>
                    <li>Valued</li>
                    <li>Creative</li>
                    <li>Thankful</li>
                    <li>Intimate</li>
                    <li>Inspired</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'sad'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Sad</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Lonely</li>
                    <li>Vulnerable</li>
                    <li>Despair</li>
                    <li>Guilty</li>
                    <li>Depressed</li>
                    <li>Hurt</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Isolated</li>
                    <li>Victimised</li>
                    <li>Powerless</li>
                    <li>Remorseful</li>
                    <li>Inferior</li>
                    <li>Embarrassed</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Abandoned</li>
                    <li>Fragile</li>
                    <li>Grief</li>
                    <li>Ashamed</li>
                    <li>Empty</li>
                    <li>Disappointed</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'disgust'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Disgust</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Disapproving</li>
                    <li>Disappointed</li>
                    <li>Awful</li>
                    <li>Repelled</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Judgemental</li>
                    <li>Appaled</li>
                    <li>Nauseated</li>
                    <li>Horrified</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Embarrassed</li>
                    <li>Revolted</li>
                    <li>Detestable</li>
                    <li>Hesitant</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'angry'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Angry</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Let Down</li>
                    <li>Humiliated</li>
                    <li>Bitter</li>
                    <li>Mad</li>
                    <li>Aggressive</li>
                    <li>Frustrated</li>
                    <li>Distant</li>
                    <li>Critical</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Betrayed</li>
                    <li>Disrespected</li>
                    <li>Indignant</li>
                    <li>Furious</li>
                    <li>Provoked</li>
                    <li>Infuriated</li>
                    <li>Withdrawn</li>
                    <li>Sceptical</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Resentful</li>
                    <li>Ridiculed</li>
                    <li>Violated</li>
                    <li>Jealous</li>
                    <li>Hostile</li>
                    <li>Annoyed</li>
                    <li>Numb</li>
                    <li>Dismissive</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'fearful'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Fearful</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Scared</li>
                    <li>Anxious</li>
                    <li>Insecure</li>
                    <li>Weak</li>
                    <li>Rejected</li>
                    <li>Threatened</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Helpless</li>
                    <li>Overwhelmed</li>
                    <li>Inadequate</li>
                    <li>Worthless</li>
                    <li>Excluded</li>
                    <li>Nervous</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Frightened</li>
                    <li>Worried</li>
                    <li>Inferior</li>
                    <li>Insignificant</li>
                    <li>Persecuted</li>
                    <li>Exposed</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'bad'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Bad</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Tired</li>
                    <li>Stressed</li>
                    <li>Busy</li>
                    <li>Bored</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Unfocused</li>
                    <li>Out of Control</li>
                    <li>Rushed</li>
                    <li>Apathetic</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Sleepy</li>
                    <li>Overwhelmed</li>
                    <li>Pressured</li>
                    <li>Indifferent</li>
                </ul>
            </div>
        </div>
        <div v-show="selectedEmotion == 'surprise'" class="emotion_row row flush">
            <div class="title_row span_4_xs">
                <h1 class="emotion_title">Surprise</h1>
            </div>
            <div class="span_4_xs sub_row_1">
                <ul class="emotion_list">
                    <li>Startled</li>
                    <li>Confused</li>
                    <li>Amazed</li>
                    <li>Excited</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_2">
                <ul class="emotion_list">
                    <li>Shocked</li>
                    <li>Disillusioned</li>
                    <li>Astonished</li>
                    <li>Eager</li>
                </ul>
            </div>
            <div class="span_2_xs sub_row_3">
                <ul class="emotion_list">
                    <li>Dismayed</li>
                    <li>Perplexed</li>
                    <li>Awe</li>
                    <li>Energetic</li>
                </ul>
            </div>
        </div>
        <div class="exit" v-on:click="close">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g fill="#FFF" fill-rule="evenodd">
                    <circle cx="14" cy="14" r="12" fill="none" stroke="#FFF" stroke-width="2"/>
                    <path d="M21 8.4L19.6 7 14 12.6 8.4 7 7 8.4l5.6 5.6L7 19.6 8.4 21l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6"/>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['active', 'selectedEmotion'],
        methods: {
            close() {
                this.$emit('emotionexpandclosed');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/variables';

    #emotion_expand {
        position: absolute;
        top: 0;
        left: 100%;
        width: 100%;
        height: 100%;
        transition: left 500ms ease-out;

        &.active {
            left: 0;
        }

        &.happy {
            background-color: $m_green_light;
            .title_row {
                background-color: $m_green_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_green;
                }

                &:nth-child(even) {
                    background-color: $m_green_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_green_light;
                }

                &:nth-child(even) {
                    background-color: $m_green;
                }
            }
        }
        &.sad {
            background-color: $m_blue;

            .title_row {
                background-color: $m_blue_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_blue;
                }

                &:nth-child(even) {
                    background-color: $m_blue_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_blue_light;
                }

                &:nth-child(even) {
                    background-color: $m_blue;
                }
            }
        }
        &.disgust {
            background-color: $m_purple;

            .title_row {
                background-color: $m_purple_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_purple;
                }

                &:nth-child(even) {
                    background-color: $m_purple_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_purple_light;
                }

                &:nth-child(even) {
                    background-color: $m_purple;
                }
            }
        }
        &.angry {
            background-color: $m_red;

            .title_row {
                background-color: $m_red_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_red;
                }

                &:nth-child(even) {
                    background-color: $m_red_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_red_light;
                }

                &:nth-child(even) {
                    background-color: $m_red;
                }
            }
        }
        &.fearful {
            background-color: $m_orange;

            .title_row {
                background-color: $m_orange_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_orange;
                }

                &:nth-child(even) {
                    background-color: $m_orange_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_orange_light;
                }

                &:nth-child(even) {
                    background-color: $m_orange;
                }
            }
        }
        &.bad {
            background-color: $m_gold;

            .title_row {
                background-color: $m_gold_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_gold;
                }

                &:nth-child(even) {
                    background-color: $m_gold_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_gold_light;
                }

                &:nth-child(even) {
                    background-color: $m_gold;
                }
            }
        }
        &.surprise {
            background-color: $m_yellow;

            .title_row {
                background-color: $m_yellow_light;
            }

            .sub_row_1 li {
                &:nth-child(odd) {
                    background-color: $m_yellow;
                }

                &:nth-child(even) {
                    background-color: $m_yellow_dark;
                }
            }

            .sub_row_2 li, .sub_row_3 li {
                &:nth-child(odd) {
                    background-color: $m_yellow_light;
                }

                &:nth-child(even) {
                    background-color: $m_yellow;
                }
            }
        }
    }

    .emotion_row {
        height: 100%;
    }

    .title_row {
        position: relative;
    }

    .sub_row_1 li {
        font-size: 36px;
    }

    .sub_row_2 li, .sub_row_3 li {
        font-size: 24px;
    }

    .emotion_title {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        color: white;
        text-align: center;
    }

    .emotion_list {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            line-height: 66px;
            height: 66px;
            color: white;
            padding-left: 24px;
        }
    }

    .exit {
        position: absolute;
        top: 24px;
        left: 24px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// emotion_expand.vue?74ac2a79